// extracted by mini-css-extract-plugin
export default {"manageFeedButton":"ManageFeedButton_manageFeedButton__FK-0N"};